import { gql } from 'apollo-boost'

export const DELETE_TEMPLATE = gql`
  mutation deleteOneTemplate($where: TemplateWhereUniqueInput!) {
    deleteOneTemplate(where: $where) {
      id
    }
  }
`
